const getEnvironmentVariables = () => {
  if (
    window.location.host.includes("localhost") ||
    window.location.host.includes("127.0.0.1")
  ) {
    return {
      s3MediaBaseUrl:
        "https://s3.ap-southeast-1.amazonaws.com/ocelotlinks.com/ocelot/",
      // REACT_APP_CENTRAL_AUTH: "http://localhost:6001",
      REACT_APP_CENTRAL_AUTH: "https://central-auth-staging.ocelotlinks.com",
      REACT_APP_REST_API: "http://localhost:9002",
      REACT_APP_KEYCLOAK_URL: "https://sso-staging.ocelotlinks.com",
      REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
      REACT_APP_KEYCLOAK_CLIENTID: "myclient",
      REACT_APP_ENVIRONMENT: "local",
      SHOW_LOCAL_FEATURES: false,
      // RUM disabled locally (empty URL → initRUM no-ops). Set a URL to test.
      REACT_APP_FARO_URL: "",
      REACT_APP_FARO_APP_NAME: "inventory",
      REACT_APP_FARO_SAMPLE_RATE: "1",
      REACT_APP_GOOGLE_MAPS_API_KEY: "AIzaSyCAD2qoKQJW7Y6koFjM8zfqzC4F3a1jJkA",
      HOME_URL: "http://localhost:3000",
      KRA_QR_CODE_BASE_URL:
        "https://etims-sbx.kra.go.ke/common/link/etims/receipt/indexEtimsInvoiceData?Data=",
      LOGISTICS_URL: "http://localhost:5005",
    };
    // return {
    //   s3MediaBaseUrl:
    //     "https://s3.ap-southeast-1.amazonaws.com/ocelotlinks.com/ocelot/",  //live connection with local
    //   REACT_APP_CENTRAL_AUTH: "https://central-auth.ocelotlinks.com",
    //   REACT_APP_REST_API: "http://localhost:3014",
    //   REACT_APP_KEYCLOAK_URL: "https://sso.ocelotlinks.com",
    //   REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
    //   REACT_APP_KEYCLOAK_CLIENTID: "myclient",
    //   REACT_APP_ENVIRONMENT: "production",
    //   HOME_URL: "http://localhost:3000",
    // };
  } else if (
    window.location.host.includes(
      "inventory-staging.ocelotlinks.com"
    )
  ) {
    return {
      s3MediaBaseUrl:
        "https://s3.ap-southeast-1.amazonaws.com/ocelotlinks.com/ocelot/",
      REACT_APP_CENTRAL_AUTH: "https://central-auth-staging.ocelotlinks.com",
      REACT_APP_REST_API: "https://api-staging.ocelotlinks.com",
      REACT_APP_KEYCLOAK_URL: "https://sso-staging.ocelotlinks.com",
      REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
      REACT_APP_KEYCLOAK_CLIENTID: "myclient",
      REACT_APP_ENVIRONMENT: "staging",
      SHOW_LOCAL_FEATURES: false,
      REACT_APP_FARO_URL: "https://faro.ocelotlinks.com/collect",
      REACT_APP_FARO_APP_NAME: "inventory",
      REACT_APP_FARO_SAMPLE_RATE: "1",
      REACT_APP_GOOGLE_MAPS_API_KEY: "AIzaSyCAD2qoKQJW7Y6koFjM8zfqzC4F3a1jJkA",
      HOME_URL: "https://staging.ocelotlinks.com/",
      KRA_QR_CODE_BASE_URL:
        "https://etims-sbx.kra.go.ke/common/link/etims/receipt/indexEtimsInvoiceData?Data=",
      LOGISTICS_URL: "https://logistics-staging.ocelotlinks.com/",
    };
  } else if (
    window.location.host.includes("inventory.ocelotlinks.com")
  ) {
    return {
      s3MediaBaseUrl:
        "https://s3.ap-southeast-1.amazonaws.com/ocelotlinks.com/ocelot/",
      REACT_APP_CENTRAL_AUTH: "https://central-auth.ocelotlinks.com",
      REACT_APP_REST_API: "https://api.ocelotlinks.com",
      REACT_APP_KEYCLOAK_URL: "https://sso.ocelotlinks.com",
      REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
      REACT_APP_KEYCLOAK_CLIENTID: "myclient",
      REACT_APP_ENVIRONMENT: "production",
      SHOW_LOCAL_FEATURES: false,
      REACT_APP_FARO_URL: "https://faro.ocelotlinks.com/collect",
      REACT_APP_FARO_APP_NAME: "inventory",
      // Verifying the RUM pipeline → sample 100%. Once /collect is confirmed in
      // Grafana, dial back to ~"0.3" to bound Loki/Tempo volume.
      REACT_APP_FARO_SAMPLE_RATE: "1",
      REACT_APP_GOOGLE_MAPS_API_KEY: "AIzaSyCAD2qoKQJW7Y6koFjM8zfqzC4F3a1jJkA",
      HOME_URL: "https://ocelotlinks.com/",
      KRA_QR_CODE_BASE_URL:
        "https://etims.kra.go.ke/common/link/etims/receipt/indexEtimsInvoiceData?Data=",
      LOGISTICS_URL: "https://logistics.ocelotlinks.com/",
    };
  } else if (
    window.location.host.includes("inventory-dev.ocelotlinks.com")
  ) {
    // New Coolify/Traefik cluster (frontends on VPS-2/3, backends on VPS-4a/4b).
    return {
      s3MediaBaseUrl:
        "https://s3.ap-southeast-1.amazonaws.com/ocelotlinks.com/ocelot/",
      REACT_APP_CENTRAL_AUTH: "https://central-auth-dev.ocelotlinks.com",
      REACT_APP_REST_API: "https://api-dev.ocelotlinks.com",
      REACT_APP_KEYCLOAK_URL: "https://sso-dev.ocelotlinks.com",
      REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
      REACT_APP_KEYCLOAK_CLIENTID: "myclient",
      REACT_APP_ENVIRONMENT: "staging",
      SHOW_LOCAL_FEATURES: false,
      REACT_APP_FARO_URL: "https://faro.ocelotlinks.com/collect",
      REACT_APP_FARO_APP_NAME: "inventory",
      REACT_APP_FARO_SAMPLE_RATE: "1",
      REACT_APP_GOOGLE_MAPS_API_KEY: "AIzaSyCAD2qoKQJW7Y6koFjM8zfqzC4F3a1jJkA",
      HOME_URL: "https://dev.ocelotlinks.com/",
      KRA_QR_CODE_BASE_URL:
        "https://etims-sbx.kra.go.ke/common/link/etims/receipt/indexEtimsInvoiceData?Data=",
      LOGISTICS_URL: "https://logistics-staging.ocelotlinks.com/",
    };
  } else {
    throw new Error("Unsupported hostname");
  }
};

export const ENV = getEnvironmentVariables();
